module.exports = __webpack_public_path__ + "img/oldFour.4107cecb.png";